export default function OrbitDuelIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="32" r="20" fill="none" stroke="#3B434F" strokeWidth="2.5" strokeDasharray="4 5" />
      <circle cx="32" cy="32" r="7" fill="#E7ECF3" />
      <path d="M12 26 L20 44 L12 40 L5 44 Z" fill="#2F8BFF" />
      <path d="M52 38 L44 20 L52 24 L59 20 Z" fill="#FF8A1F" />
      <circle cx="21" cy="17" r="2.5" fill="#E7ECF3" />
    </svg>
  );
}
